import { useCallback, useContext } from "react";
import { HotelContext } from "../context/hotel";
import useApi from "../hooks/useApi";
import { parsePreferences } from "../functions";

const useFoodMenu = () => {
    const { get } = useApi();
    const { data } = useContext(HotelContext);

    const getFoodMenu = useCallback(async (restaurantId, id) => {
        try {
            let _endpoint = `hotels/${data.id}/menus/${id}`;
            if (!isNaN(id) && id < 15) {
                _endpoint = `hotels/${data.id}/restaurants/${restaurantId}/menus_by_position/${id}`;
            }
            const response = await get(_endpoint);
            // La API devuelve item.preferences como string JSON; lo normalizamos a
            // objeto aca (chokepoint comun de Service, PublicCart y MenuCommerce)
            // para evitar que Object.keys() itere caracteres y genere combos vacios.
            if (response?.content && Array.isArray(response.content)) {
                response.content.forEach((section) => {
                    section?.items?.forEach((item) => {
                        if (item) item.preferences = parsePreferences(item.preferences);
                    });
                });
            }
            return response;
        } catch (error) {
            console.error('Error:', error);
            throw error;
        }
    }, [data?.id, get]);

    return { getFoodMenu };
};

export default useFoodMenu;
